import { Theme } from '@mui/material/styles';
// import { checkboxClasses } from '@mui/material/Checkbox';

// ----------------------------------------------------------------------

export function checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
          // [`&.${checkboxClasses.colorPrimary}`]: {
          //   color: theme.palette.secondary.main,
          // },
        },
      },
    },
  };
}
